/** This is a second action bar that appears below extra long journal/lit content */
import React, { useState, useRef, useLayoutEffect } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import ActionBar from '..';
import {
  ActionBarContext,
  SecondaryActionBarContext,
} from '../ActionBarContext';

export interface Props {
  deviation: PapiDeviation;
  wrapperClassName?: string;
}

const SecondaryActionBar: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  wrapperClassName,
  deviation,
}) => {
  const anchorRef = useRef<HTMLDivElement>(null);
  const topBarRef = useRef<HTMLElement | null>(null);

  const [showSecondaryActionBar, setShowSecondaryActionBar] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useLayoutEffect(() => {
    const content = topBarRef.current;
    const anchor = anchorRef && anchorRef.current;
    if (!content || !anchor || typeof window === 'undefined') {
      return;
    }

    const top = content.getBoundingClientRect().top;
    const bottom = anchor.getBoundingClientRect().top;

    setShowSecondaryActionBar(bottom - top > window.innerHeight);
  });

  return (
    <SecondaryActionBarContext.Provider
      value={{
        setTopActionBarRef: refNode => {
          topBarRef.current = refNode;
        },
      }}
    >
      {children}
      {/* we need to float our anchor point to deal with the floated columns */}
      <div ref={anchorRef} style={{ width: 1, float: 'left' }} />
      {showSecondaryActionBar && (
        <div className={wrapperClassName}>
          <ActionBarContext.Provider value="secondary">
            <ActionBar deviation={deviation} />
          </ActionBarContext.Provider>
        </div>
      )}
    </SecondaryActionBarContext.Provider>
  );
};
SecondaryActionBar.displayName = 'SecondaryActionBar';

export default SecondaryActionBar;
